import { TEAM_TYPES } from 'common/constants/constants';
import useQueryParams from 'components/hooks/useQueryParams';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { teamsByIdSelector } from 'state/selectors/teams';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import useRestoreFromStorage from 'common/hooks/storage/useRestoreFromStorage';
import { TEAM_SPACE_STORAGE_KEYS } from '../../team-space.consts';
import { useLocation } from 'react-router';

const useDefaultTeam = () => {
  const location = useLocation();
  const locationDefaultTeamId = location?.state?.defaultTeamId;

  const teamsById = useSelector(teamsByIdSelector);
  const { getQueryParam } = useQueryParams();
  const contextQs = getQueryParam('context');
  const teamIdQs = getQueryParam('teams');

  const teamIdFromStorage = useRestoreFromStorage({
    key: TEAM_SPACE_STORAGE_KEYS.TEAM_ID,
    defaultValue: null
  });

  const globalTeam = useSelector(selectedTeamSelector);
  const isGlobalTeamLegal =
    globalTeam?.id &&
    globalTeam.type !== TEAM_TYPES.ALL_TEAMS &&
    globalTeam.type !== TEAM_TYPES.ALL_CONTRIBUTORS &&
    globalTeam.type !== TEAM_TYPES.GROUP;

  const defaultTeam = useMemo(() => {
    if (locationDefaultTeamId) {
      return teamsById[locationDefaultTeamId];
    }
    if (contextQs && teamIdQs) {
      return teamsById[teamIdQs];
    }
    if (teamsById[teamIdFromStorage]) {
      return teamsById[teamIdFromStorage];
    }

    return isGlobalTeamLegal ? globalTeam : null;
  }, [contextQs, teamIdQs, globalTeam, locationDefaultTeamId]);

  return defaultTeam;
};

export default useDefaultTeam;
